import axios from 'axios';

let debugLogger = null;

const setDebugLogger = (logger) => {
  debugLogger = logger;
};

export { setDebugLogger };

const api = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (debugLogger) {
      debugLogger('request', `${config.method?.toUpperCase()} ${config.url}`, {
        headers: { ...config.headers, Authorization: token ? 'Bearer ***' : undefined },
        data: config.data
      });
    }
    return config;
  },
  (error) => {
    if (debugLogger) {
      debugLogger('error', 'Request error', { message: error.message });
    }
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (debugLogger) {
      debugLogger('response', `${response.config.method?.toUpperCase()} ${response.config.url} - ${response.status}`, {
        status: response.status,
        data: response.data
      });
    }
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      // Don't redirect for auth endpoint failures (login with wrong credentials)
      // Only redirect for expired sessions on protected routes
      const isAuthEndpoint = error.config?.url?.includes('/api/auth/login');
      if (!isAuthEndpoint) {
        localStorage.removeItem('access_token');
        window.location.href = '/auth';
      }
    }
    if (debugLogger) {
      debugLogger('error', `Response error: ${error.response?.status || 'Network Error'}`, {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
    }
    return Promise.reject(error);
  }
);

export default api;
